module.exports = __webpack_public_path__ + "img/wendu2.gif";